<template>
  <nav id="header" class="fixed w-full z-30 top-0 text-white navbackground" >
    <div
      class="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-2"
    >
      <div class="pl-4 flex items-center">
        <a class="toggleColour text-white no-underline hover:no-underline font-bold text-2xl lg:text-4xl"
          href="https://company.geodir.co">          
          Geodir
        </a>
      </div>

      <div class="block lg:hidden pr-4" v-if="isMObile">
        <button @click="menuIsVisible = !menuIsVisible"
          id="nav-toggle"
          class="flex items-center p-1 text-orange-800 hover:text-gray-900"
        >
          <svg
            class="fill-current h-6 w-6"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>

      <div v-if="menuIsVisible"
        class="w-full flex-grow lg:flex lg:items-center lg:w-auto lg:block mt-2 lg:mt-0 bg-white lg:bg-transparent text-black p-4 lg:p-0 z-20"
        id="nav-content"
      >
        <ul class="list-reset lg:flex justify-end flex-1 items-center">
          <li class="mr-3">
            <a
              class="inline-block py-2 px-4 text-black font-bold no-underline text-white"
              href="/"
              >Home</a
            >
          </li>
          <li class="mr-3">
            <a
              class="inline-block py-2 px-4 text-black font-bold no-underline text-white"
              href="https://docs.geodir.co" target="_blank"
              >Documentation</a
            >
          </li>
          <li class="mr-3">
            <el-dropdown class="inline-block py-2 px-4 font-bold no-underline text-white">
              <span class="el-dropdown-link">
                Company<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><a
              class="inline-block py-2 px-4 text-black font-bold no-underline"
              href="https://account.geodir.co" target="_blank"
              >About</a
            ></el-dropdown-item>
                <!-- <el-dropdown-item><a
              class="inline-block py-2 px-4 text-black font-bold no-underline"
              href="/Acercade"
              >About</a
            ></el-dropdown-item> -->
               
                <el-dropdown-item><a
              class="inline-block py-2 px-4 text-black font-bold no-underline"
              href="/Legal"
              >Legal</a
            ></el-dropdown-item>

            <el-dropdown-item>
              <a class="inline-block py-2 px-4 text-black font-bold no-underline"
                href="/resources/ecommerce">Ecommerce</a>
            </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="mr-3">
            <a
              class="inline-block py-2 px-4 text-black font-bold no-underline text-white"
              href="https://medium.com/@geodir" target="_blank"
              >Blog</a
            >
          </li>
        </ul>

        <button v-show="!checkLogin" v-on:click="login()"
          id="navAction"
          class="mx-auto lg:mx-0 hover:underline bg-white text-gray-800 font-bold rounded-full mt-4 lg:mt-0 py-4 px-8 shadow opacity-75"
        >
          Login
        </button>

        <div class="relative " v-if="!isMObile && checkLogin">
          <button @click="isOpen = !isOpen" class="relative z-10 block h-12 w-12 rounded-full overflow-hidden border-2 border-gray-600 focus:outline-line focus:border-white">
            <img class="h-full w-full object-cover"  src="../../src/assets/img/user-icon.png" alt="" />
          </button>
          <button v-if="isOpen" @click="isOpen = false" tabindex="-1" class="fixed inset-0 h-full w-full bg-black opacity-50 cursos-default"></button>
          <div v-if="isOpen" class="absolute top-auto right-0 mt-2 py-2 w-48 bg-white rounded-lg shadow-xl">
            <a href="account" class="block px-4 py-2 text-gray-800 hover:bg-indigo-500 hover:text-white">Account</a>
            <a href="#" class="block px-4 py-2 text-gray-800 hover:bg-indigo-500 hover:text-white" @click="logout()">Sign out</a>
          </div>
        </div>

        <!-- Para movil -->
        <div v-if="isMObile && isLogged" class="px-4 py-4 border-t border-gray-800 ">
          <div class="flex items-center">
            <img class="h-8 w-8 border-2 border-gray-600 rounded-full object-cover"  src="../../src/assets/img/hero_employee_.svg">
            <span class="font-semibold ml-3 text-gray-800">jane</span>
          </div>

          <div class="mt-4">
            <a href="account" class="mt-2 block text-gray-800 hover:text-white">Account</a>
            <a href="#" class="mt-2 block text-gray-400 hover:text-white" @click="logout()">Sign out</a>
          </div>
        </div>

      </div>
    </div>

    <hr class="border-b border-gray-100 opacity-25 my-0 py-0" />
  </nav>
</template>

<script>
const $ = require('jquery')

export default {
  
  data(){
    return {
      isOpen: false,
      isMObile: false,
      menuIsVisible: true,
      isLogged: false
    }
  },
  created(){

    console.log('es movil');

    console.log(this.$isMobile())


      let paramOfAccess =this.$route.params.access;
      
      console.log('acceso');
      console.log(paramOfAccess);
      if (paramOfAccess == 'userLogged') {
        this.login();
      }

    this.isLogged = this.$store.state.isLoggedIn;

    this.isMObile = this.$isMobile();

    if(this.isMObile){
      this.menuIsVisible = false;
    }


    const handleEscape = (e) => {
      if(e.key === 'Esc' || e.key === 'Escape'){
        this.isOpen = false;
      }
    }

    document.addEventListener('keydown', handleEscape);
    
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keydown', handleEscape);
    })

  },
  computed: {
    checkLogin() {
      return this.$store.state.isLoggedIn;
    }
  },
  methods:{
    openMenu(){
      this.menuIsVisible
    },

    login(){
      console.log('login');
      console.log(this.$route.fullPath);

      
      let params = {};
      params.redirect_uri = process.env.VUE_APP_URL_REDIRECT_URL + '/geodir';

      params.client_id = process.env.VUE_APP_URL_OAUTH_ID;
      params.response_type = "code";
      params.scope = "maps geocoding builder";
      params.state = '152fgfd5';
      var recursiveDecoded = decodeURIComponent($.param(params));

     
      console.log();
      //localStorage.setItem("LOGINREDIRECT", JSON.stringify(redirectLogin));
      //redirect for oauth
      window.location =
         process.env.VUE_APP_SEGURIDAD + "/oauth/authorize" +
        "?" +
        recursiveDecoded;

    },
    logout(){
      var app = this;
      localStorage.removeItem("geodir_Token");

      app.$store.state.isLoggedIn = false;

      window.location.href  = process.env.VUE_APP_URL_REDIRECT_URL_PRINCIPAL;

    }
  }
};
</script>
<style scoped>
.navbackground{
  background: linear-gradient(90deg, #9f33d5 0%, #517dda 100%);

}

.el-dropdown-link {
    cursor: pointer;
    color: white;
  }
</style>
